import { injectable } from 'inversify';
import { Result } from '@Redux/type';
import { getArmyListUnits } from '@Selectors/builder/myArmyList/make/unit/edit/selector/editSelector';
import armyListSlice from '@Redux/reducers/builder/armyList.slice';

@injectable()
export class ArmyListUnitModelRuleTroopAction {
  public selectArmyListUnitModelRule =
    (armyListUnitId: string, armyListUnitModelRuleId: string): Result<void> =>
    async (dispatch, getState) => {
      const armyListUnit = getArmyListUnits(getState()).find(
        (item) => item.id === armyListUnitId,
      );
      if (!armyListUnit) return;

      const armyListUnitModelRule = armyListUnit.modelRuleUnitTroops.find(
        (item) => item.id === armyListUnitModelRuleId,
      );
      if (!armyListUnitModelRule) return;

      armyListUnitModelRule.isSelected = !armyListUnitModelRule.isSelected;

      dispatch(armyListSlice.actions.updateArmyListUnit(armyListUnit));
    };
}
